import { Component, Input, OnInit } from '@angular/core';
import { TwoWayBoundComponent } from '@app/shared/components/base/two-way-bound.component';
import { Gender } from '@app/shared/models/gender';

@Component({
    selector: 'gender-twb',
    templateUrl: './gender.component.html',
    styleUrls: ['./gender.component.scss']
})
export class GenderComponent extends TwoWayBoundComponent<Gender> implements OnInit {

    @Input()
    public asCode?: boolean; // Some elements need gender or title as M / F, while for others the backend needs MALE / FEMALE

    get gender(): Gender {
        return this.bananaBox;
    }

    set gender(gender: Gender) {
        this.bananaBox = gender;
    }

    get Gender() {
        return Gender;
    }

    constructor() {
        super();
    }

    public ngOnInit() {
        super.ngOnInit();

        if (!this.gender) {
            this.gender = Gender.UNKNOWN;
        }
    }
}
